export default __webpack_public_path__ + "static/media/best_seller.30329027.png";